module.exports = __webpack_public_path__ + "4ce6a560d4d20ba5d553e8c0cd1b9b1a.svg";